import { ECampaignSubmissionStatus } from 'src/enums'

export const CAMPAIGN_SUBMISSION_STATUS_TEXT = {
  [ECampaignSubmissionStatus.ALL]: 'All',
  [ECampaignSubmissionStatus.PASSED]: 'Passed',
  [ECampaignSubmissionStatus.TO_REVIEW]: 'To Review',
  [ECampaignSubmissionStatus.GREAT_MATCH]: 'Great Match',
  [ECampaignSubmissionStatus.POSSIBLE_MATCH]: 'Possible Match',
  [ECampaignSubmissionStatus.NOT_A_MATCH]: 'Not a Match'
}
